import request from './request'
import * as http from '@/libs/http'

/**
 * パスワードリセットの確認メールを送信する
 *
 * @param {String} orgcode 組織コード
 * @param {Object} data ログイン情報
 * @returns {Response} レスポンスデータ
 */
export function verifyReset (orgcode, email) {
  return request.post(`/org/${orgcode}/verify/reset`, {
    email
  }, {
    validateStatus: (status) => [
      http.OK,
      http.NotFound,
      http.Forbidden
    ].includes(status)
  })
}
